/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArchiveTemplate } from '../../models/archive-template';

export interface PatientArchiveGetArchiveTemplate$Params {
  TemplateFileName?: string | null;
}

export function patientArchiveGetArchiveTemplate(http: HttpClient, rootUrl: string, params?: PatientArchiveGetArchiveTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ArchiveTemplate>>> {
  const rb = new RequestBuilder(rootUrl, patientArchiveGetArchiveTemplate.PATH, 'get');
  if (params) {
    rb.query('TemplateFileName', params.TemplateFileName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ArchiveTemplate>>;
    })
  );
}

patientArchiveGetArchiveTemplate.PATH = '/api/PatientArchive';
